(() => {
  // One-click dark/light toggle. A saved 'light'/'dark' wins; otherwise follow the OS setting.
  const storageKey = 'bird-habit-color-mode';
  const root = document.documentElement;
  const systemPreference = window.matchMedia('(prefers-color-scheme: dark)');

  const storedMode = () => {
    try {
      const value = window.localStorage.getItem(storageKey);
      return value === 'light' || value === 'dark' ? value : null;
    } catch (_error) {
      return null;
    }
  };

  const currentMode = () => storedMode() || (systemPreference.matches ? 'dark' : 'light');

  const updateControls = (mode) => {
    const next = mode === 'dark' ? 'light' : 'dark';
    document.querySelectorAll('[data-bird-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(mode === 'dark'));
      button.setAttribute('title', `Switch to ${next} mode`);
    });
  };

  const applyMode = (mode, persist = false) => {
    root.dataset.colorMode = mode;
    delete root.dataset.colorModePreference;
    root.style.colorScheme = mode;
    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) themeColor.content = mode === 'dark' ? '#101510' : '#ffffff';
    if (persist) {
      try {
        window.localStorage.setItem(storageKey, mode);
      } catch (_error) {
        // Mode still applies for this visit when storage is unavailable.
      }
    }
    updateControls(mode);
    document.dispatchEvent(new CustomEvent('bird:color-mode-change', { detail: { mode } }));
  };

  const hydrate = () => applyMode(currentMode());

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-bird-theme-toggle]')) return;
    applyMode(root.dataset.colorMode === 'dark' ? 'light' : 'dark', true);
  });

  document.addEventListener('shopify:section:load', hydrate);

  systemPreference.addEventListener('change', () => {
    if (!storedMode()) hydrate();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  } else {
    hydrate();
  }
})();
